import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Breadcrumbs for internal pages (also aids SEO / orientation).
export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="container-x pt-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs font-semibold text-mutedgreen" data-testid="breadcrumbs">
        <li><Link to="/" className="hover:text-gold-dark">Home</Link></li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="h-3.5 w-3.5 opacity-60" />
            {item.to ? (
              <Link to={item.to} className="hover:text-gold-dark">{item.label}</Link>
            ) : (
              <span className="text-forest">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
